<template>
  <el-dialog
    fullscreen
    :title="title"
    v-if="visible"
    :visible.sync="visible"
    :before-close="() => close()"
    :close-on-click-modal="false"
  >
    <MaterialDetail
      ref="materialDetail"
      :openType="type"
      :parmsData="params"
      @reload="(val) => $emit('reload', val)"
    />
    <span slot="footer"> </span>
  </el-dialog>
</template>
<script>
import MaterialDetail from '@/views/backstage/sample/sampleInformation/detail'
export default {
  components: { MaterialDetail },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    title: { type: String, default: '' },
    params: { type: Object, default: () => {} },
  },
  methods: {
    close() {
      if (this.type === 'detail') {
        this.submitClose()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗?',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => this.submitClose())
    },
    submitClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
